

























import { EmailService } from "@/services/api/email.service";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FVerify extends Vue {
  messageScr: string = null as any;

  public async clickBack() {
    this.$router.push({ name: "auth" });
  }
  async created() {
    const { query } = this.$route;
    if (!query.secret) {
      return this.$router.push({ name: "main" });
    }

    const resp = await EmailService.verifyUserEmail(query.secret as string);
    if (resp.result && resp.result.result == true) {
      this.messageScr = "change-email.EmailChanged";
    } else this.messageScr = `change-email.${resp.result.reason}`;
  }
}
